import React from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Switch,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import { Settings as SettingsIcon } from "@mui/icons-material";
import { blue } from "@mui/material/colors";

const PlatformBasicSettings = ({ settings, onSettingChange }) => {
  const platformSettings = settings.platformBasic;

  const handleInputChange = (key, value, type = "int") => {
    let processedValue = value;

    if (type === "int") {
      processedValue = parseInt(value) || 0;
    } else if (type === "float") {
      processedValue = parseFloat(value) || 0;
    } else if (type === "string") {
      processedValue = value;
    } else if (type === "boolean") {
      processedValue = value;
    }

    console.log(`Updating platform basic ${key} to:`, processedValue);
    onSettingChange("platformBasic", key, processedValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card elevation={3}>
          <CardHeader
            avatar={<SettingsIcon sx={{ color: blue[500] }} />}
            title="Platform Basic Settings"
            subheader="General platform configuration and settings"
            sx={{ bgcolor: blue[50] }}
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Platform Name"
                  value={platformSettings.platform_name || ""}
                  onChange={(e) =>
                    handleInputChange("platform_name", e.target.value, "string")
                  }
                  helperText="Display name for the platform"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Minimum Withdrawal Amount"
                  type="number"
                  value={platformSettings.minimum_withdrawal || ""}
                  onChange={(e) =>
                    handleInputChange("minimum_withdrawal", e.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  helperText="Minimum amount users can withdraw"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Daily Transactions"
                  type="number"
                  value={platformSettings.max_daily_transactions || ""}
                  onChange={(e) =>
                    handleInputChange("max_daily_transactions", e.target.value)
                  }
                  helperText="Maximum transactions per user per day"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Transaction Fee (%)"
                  type="number"
                  value={platformSettings.transaction_fee_percentage || ""}
                  onChange={(e) =>
                    handleInputChange(
                      "transaction_fee_percentage",
                      e.target.value,
                      "float"
                    )
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                  helperText="Platform fee on transactions"
                  inputProps={{ step: "0.1" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={platformSettings.maintenance_mode || false}
                      onChange={(e) =>
                        handleInputChange(
                          "maintenance_mode",
                          e.target.checked,
                          "boolean"
                        )
                      }
                    />
                  }
                  label="Maintenance Mode"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={platformSettings.registration_enabled || false}
                      onChange={(e) =>
                        handleInputChange(
                          "registration_enabled",
                          e.target.checked,
                          "boolean"
                        )
                      }
                    />
                  }
                  label="Registration Enabled"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PlatformBasicSettings;
